const { useState, useEffect } = require("react");
const { debounce } = require("../utils/debounce");

const useResponsive = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [isDesktop, setIsDesktop] = useState(width > 1024);

  useEffect(() => {
    const handleResize = debounce(() => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      setIsDesktop(newWidth > 1024);
    }, 100);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const calculateWidths = () => {
    if (width >= 1440) {
      return { expanded: 256, collapsed: 84 };
    }

    if (width > 1024) {
      const ratio = (width - 1024) / (1440 - 1024);
      return {
        expanded: Math.round(200 + 56 * ratio),
        collapsed: Math.round(66 + 18 * ratio),
      };
    }

    return { expanded: 256, collapsed: 84 };
  };

  return {
    ...calculateWidths(),
    isDesktop,
    windowWidth: width,
  };
};

export default useResponsive;
